import React, { useEffect } from "react";
import { Typography } from "@mui/material";

const CondicionesUso = () => {
  useEffect(() => {
    window.scrollTo(0, -0);
  }, []);

  return (
    <main>
      <Typography gutterBottom color="textPrimary" variant="h3" mt={10} mb={5}>
        TERMINOS Y CONDICIONES DEL SERVICIO DE WWU
      </Typography>
      <Typography gutterBottom align="justify" color="textPrimary">
        Las presentes condiciones generales de contratación (en adelante, las
        ''Términos y condiciones'') tienen por objeto regular las condiciones
        en que los candidatos y las empresas (en adelante el o los
        ''Usuario(s)'') pueden utilizar el servicio ofrecido por WWU MÉXICO,
        SOCIEDAD ANÓNIMA PROMOTORA DE INVERSIÓN DE CAPITAL VARIABLE, con
        domicilio social en Ciudad de México, Bahía de Santa Bárbara #145,
        Col. Verónica Anzures, C.P. 11300, ('WWU'), a través de una aplicación
        para dispositivos móviles y una aplicación web (en adelante las
        aplicaciones se denominarán el ''Servicio''). Cualquier usuario que
        acceda al Servicio se compromete a respetar los presentes Términos y
        condiciones. WWU podrá modificar el contenido de los presentes
        Términos y condiciones dando aviso de estas modificaciones al Usuario.
        En la comunicación remitida a estos efectos, WWU facilitará al Usuario
        la información relativa a la modificación. La versión de los Términos
        y condiciones aplicables son las que se encuentran disponibles en
        línea en cada inicio de sesión. Si el Usuario no acepta los nuevos
        Términos y condiciones, le corresponde a él el darse de baja
        inmediatamente del Servicio, en su defecto, se considerará que las ha
        aceptado.
      </Typography>
      <Typography gutterBottom color="textPrimary" variant="h5">
        1. DESCRIPCIÓN DEL SERVICIO
      </Typography>
      <Typography gutterBottom align="justify" color="textPrimary">
        El Servicio consiste en una plataforma que permite el encuentro entre
        profesionales, organizaciones y empresas que ofrecen puestos de
        trabajo (en adelante ''Empresa'') y particulares o profesionales que
        demandan empleo (en adelante, ''Candidatos''). El Servicio se ofrece a
        través de una aplicación para dispositivos móviles y una aplicación
        web cuya instalación y uso es gratuita para los Usuarios. No obstante,
        en el futuro se podrán aplicar tarifas a Usuarios Empresa que serán
        oportunamente comunicadas con antelación suficiente. El operador de
        telefonía móvil o ISP podría cobrar determinados cargos en concepto, a
        modo de ejemplo, de transferencia de datos. El Usuario será el
        responsable exclusivo del abono de las tarifas a su operador de
        telefonía o ISP por este concepto. Por favor consulta tu plan de
        precios con tu operador de telefonía móvil o ISP antes de utilizar el
        Servicio. WWU se reserva el derecho de eliminar una oferta publicada
        por la Empresa (''Oferta'') o perfil de un Candidato (''CV'') sin
        previo aviso y sin notificación previa en el caso de que WWU
        considerara, a su exclusivo criterio, que dicho CV u Oferta incumple
        alguna de las disposiciones de estos Términos y condiciones. El
        Usuario reconoce expresamente que WWU no será responsable de ninguna
        manera en el caso de cualquier directa o indirecta resultante de la
        eliminación de una Oferta o CV en este supuesto.
      </Typography>
      <Typography gutterBottom color="textPrimary" variant="h5">
        2. REGISTRO Y ACCESO
      </Typography>
      <Typography gutterBottom align="justify" color="textPrimary">
        La Empresa que accede al Servicio, a través del registro y de la
        aceptación de estos Términos y condiciones, declara expresamente que
        se encuentra debidamente habilitada para operar en el ámbito de su
        actividad y, especialmente pero sin limitación, para la contratación
        de personal. WWU ofrece el Servicio exclusivamente al Usuario como
        usuario final, por lo tanto, la reventa o comercialización del
        Servicio está estrictamente prohibida así como la subrogación o cambio
        de titularidad de este contrato. Queda prohibido el uso de la
        totalidad o parte del Servicio para fines distintos de un uso con
        fines profesionales. Por lo tanto, el Usuario se compromete a no
        reproducir, copiar, vender, revender, comercializar o explotar con
        fines comerciales o no comerciales, sujeto o no a remuneración,
        beneficio o ventaja, todo o parte del Servicio y su contenido, el uso
        del Servicio o de cualquier derecho de acceso al Servicio. El
        Candidato que acceda al Servicio lo hará únicamente con la finalidad
        de buscar un empleo. Para acceder al Servicio e identificar al Usuario
        se requiere crear una cuenta (la ''Cuenta''). El Usuario, al
        registrarse, se compromete a proporcionar información cierta, precisa,
        actual y completa acerca de su identidad, su información personal y de
        contacto (nombre, apellidos, dirección de correo electrónico). El
        Usuario actualizará de inmediato la información de su Cuenta en el que
        caso de que se produzca alguna modificación en la misma durante su
        condición de Usuario. En el caso de que el Usuario facilitara
        información falsa, inexacta, desactualizada, incompleta, engañosa o
        que puedan inducir a error, WWU podrá inmediatamente sin previo aviso
        ni derecho a indemnización por ello, suspender o cancelar la Cuenta y
        negar el acceso al Usuario, ya sea temporal o permanentemente para la
        totalidad o parte del Servicio.
      </Typography>
      <Typography gutterBottom color="textPrimary" variant="h5">
        3. OBLIGACIONES DEL CANDIDATO
      </Typography>
      <Typography gutterBottom align="justify" color="textPrimary">
        La Cuenta incluye unas credenciales de acceso del Usuario consistentes
        en una dirección de correo electrónico y contraseña, (en adelante las
        ''Credenciales''). El Usuario custodiará las Credenciales bajo su
        exclusiva responsabilidad. El Usuario se obliga a mantener la
        confidencialidad sobre las Credenciales y se compromete a notificar
        inmediatamente de su robo, pérdida o cualquier otra violación de la
        confidencialidad de sus Credenciales a WWU, el cual procederá a su
        cancelación. El Usuario es el único responsable del uso que se haga de
        sus Credenciales y de las acciones realizadas mediante el acceso al
        Servicio a través de ellas. Por lo tanto, cualquier acceso al Servicio
        a través de sus Credenciales se considerará que ha sido realizado por
        el Usuario. En este sentido, el Usuario tendrá la posibilidad de
        cerrar su sesión haciendo clic en el botón ''Cerrar sesión'' con el
        fin de evitar accesos no autorizados por él a través del dispositivo
        que hubiera utilizado previamente para iniciar la sesión en la
        aplicación.
      </Typography>
      <Typography gutterBottom color="textPrimary" variant="h5">
        4. PROPIEDAD INTELECTUAL E INDUSTRIAL
      </Typography>
      <Typography gutterBottom align="justify" color="textPrimary">
        La estructura general, las funcionalidades y todos los contenidos
        tanto del Servicio como de la aplicación móvil, de la aplicación web
        dashboard.WWU.com y de la página web https://www.WWU.com/mx/,
        publicados por WWU, son propiedad de WWU, de sus socios o WWU dispone
        de los derechos para su explotación, y están protegidos por las leyes
        mexicanas e internacionales sobre propiedad intelectual e industrial.
        Cualquier reproducción y/o representación de cualquier parte del sitio
        web y/o del Servicio, sin la autorización expresa de WWU está
        prohibido. En particular, cualquier reproducción y/o representación,
        de información completa o parcial, datos, texto, software, música,
        sonido, fotografías, imágenes, vídeos, base de datos, mensajes u otros
        elementos que se pueden ser mostrados por WWU y accesibles por los
        Usuarios, sin la autorización por escrito de WWU está prohibida. Las
        características y especificaciones del Servicio y las presentes
        Términos y condiciones son propiedad de WWU. La copia del Servicio a
        través de ingeniería inversa o cualquier otro procedimiento sin el
        permiso expreso de WWU está expresamente prohibida. WWU concede al
        Usuario un derecho de uso o licencia, no de venta, para el uso del
        Servicio que se regirá bajo los términos del presente párrafo (en
        adelante la ''Licencia''). WWU se reserva el resto de derechos que no
        conceda de manera expresa. La Licencia para la utilización del
        Servicio a través de la aplicación móvil y, en su caso, de la
        aplicación web es una licencia no transferible para el uso de tales
        aplicaciones en cualquier dispositivo compatible que posea o controle
        el Usuario, según lo permitido por las normas de uso establecidas en
        estos Términos y condiciones. Esta Licencia no permite al Usuario
        utilizar las aplicaciones en otros dispositivos que el Usuario no
        posea o controle, y no podrá difundir o hacer disponible las
        aplicaciones en una red para que pueda ser utilizada por múltiples
        dispositivos móviles al mismo tiempo. El Usuario no puede alquilar,
        arrendar, prestar, vender, redistribuir o sublicenciar las
        aplicaciones. El Usuario no podrá copiar, descompilar, realizar
        ingeniería inversa, desensamblar, intentar derivar el código fuente,
        modificar ni crear trabajos derivados de las aplicaciones, todas las
        actualizaciones, o cualquier parte de las mismas (salvo que y sólo en
        la medida en que cualquier restricción anterior esté prohibida por la
        ley aplicable o en la medida en que esté permitido por los términos de
        la licencia de uso de cualquiera de los componentes abiertos de origen
        incluidos en la Licencia). Cualquier intento de hacerlo supondrá una
        violación de los derechos de WWU. Si el Usuario incumpliera estas
        restricciones, podría conllevar como consecuencia el inicio de
        acciones legales y el pago de daños y perjuicios. Los términos de la
        Licencia regirán también cualquier actualización proporcionada por WWU
        que sustituya y/o complemente el Servicio, a menos que dicha
        actualización incluya una licencia propia, en cuyo caso los términos
        de dicha licencia regirán. La Licencia estará en vigor hasta que sea
        rescindida por el Usuario o por WWU. Los derechos otorgados bajo esta
        Licencia finalizarán sin previo aviso si el Usuario incumpliera
        cualquier término(s) de los Terminos y condiciones. A la terminación
        de la Licencia, el Usuario deberá dejar de utilizar las aplicaciones,
        y destruir o desinstalar todas las copias, totales o parciales. Los
        signos distintivos de WWU, tales como el nombre de dominio, la marca,
        nombres comerciales, son de titularidad de WWU y se encuentran
        protegidos por la Ley. La reproducción total o parcial de estos signos
        distintivos sin la autorización expresa de WWU está prohibida.
      </Typography>
      <Typography gutterBottom color="textPrimary" variant="h5">
        5. RESPONSABILIDAD
      </Typography>
      <Typography gutterBottom align="justify" color="textPrimary">
        El Usuario reconoce haber leído los presentes Términos y condiciones y
        se compromete a respetarlas. WWU se compromete a aplicar todos los
        medios a su alcance para garantizar el acceso de buena calidad al
        Servicio. WWU no ofrece ninguna garantía expresa o implícita, sin
        limitación, en cuanto a la continuidad, el rendimiento, la
        durabilidad, la calidad o la ausencia de vicio o defecto del Servicio.
        Ninguna información, ya sea oral o escrita, obtenida por el Usuario al
        utilizar el Servicio, implica ninguna garantía no expresamente
        prevista en los presentes Términos y condiciones. El Usuario reconoce
        que utiliza el Servicio bajo su propio riesgo. A menos que sea
        impuesto por la ley aplicable o se acuerde por escrito y sin perjuicio
        de lo dispuesto en el resto de Términos y condiciones, estas
        aplicaciones se proporcionan por los propietarios y los colaboradores
        tal y como son sin garantía expresa o implícita, incluyendo, pero no
        limitada a, las garantías de comercialización y aptitud para un
        propósito particular. En ningún caso, el autor o los colaboradores
        serán responsables por daños directos, indirectos, accidentales,
        especiales, ejemplares o derivados (incluyendo, pero no limitados a,
        la adquisición de bienes o servicios, la pérdida de uso, pérdida de
        empleo, de datos o de beneficios, o interrupción de la actividad),
        bajo cualquier teoría de derecho o de responsabilidad, ya sea
        contractual o extracontractual, (incluyendo negligencia o culpa o
        cualquier otro) a partir del uso de este software, incluso si se
        advierte de la posibilidad de tales daños. En la medida en que lo
        permita la Ley y salvo por lo dispuesto en su caso en el resto de los
        Términos y condiciones, en ningún caso WWU será responsable por daños
        personales, ni accidentales, especiales, directos o indirectos,
        incluyendo, sin limitación, daños por pérdida de beneficios, pérdida o
        no obtención de empleo, pérdida de datos, interrupción del negocio o
        cualquier otro daño o pérdida comercial, relacionados con el uso o
        imposibilidad de uso de la aplicación, independientemente de la causa,
        independientemente de la teoría de responsabilidad (contractual o
        extracontractual o de cualquier otra) e incluso si el Usuario ha sido
        advertido de la posibilidad de tales daños.). El Servicio se
        proporciona ''tal cual'' y es accesible sin ninguna garantía de
        disponibilidad o regularidad. WWU realizará sus mejores esfuerzos para
        que el Servicio esté disponible durante todo el día, siete días a la
        semana, excepto en casos de fuerza mayor o causa fortuita o debido a
        un evento fuera del control de WWU, sin perjuicio además de las
        interrupciones debidas a actualizaciones o mantenimientos, posibles
        fallos, los peligros carácter técnico relacionados con Internet o
        actos maliciosos por parte de terceros. Los tiempos de respuesta de la
        información contenida en la aplicación no están garantizados por WWU.
        El Usuario reconoce que la velocidad de transmisión de información es
        independiente del Servicio y depende de las características inherentes
        de las redes de comunicaciones electrónicas, las características
        técnicas del modo de conexión y la conexión a Internet del Usuario.
        Para utilizar el Servicio, el Usuario reconoce que es necesario
        disponer de acceso a Internet, cuyo coste de acceso es a su exclusivo
        cargo. WWU se reserva el derecho de cambiar en cualquier momento los
        contenidos del Servicio. WWU hará sus mejores esfuerzos para ofrecer
        información y/o herramientas disponibles y verificadas, pero no se
        hace responsable de los errores, la falta de disponibilidad de la
        información y/o de la presencia de virus en la aplicación. WWU no
        puede garantizar la exactitud, integridad, oportunidad de la
        información disponible en la aplicación. En cualquier caso, el Usuario
        reconoce expresamente que WWU no será responsable, de ninguna manera,
        por los puestos de trabajos publicados por las Empresas. La aplicación
        puede contener enlaces a sitios web publicados por terceros, para de
        los cuales WWU no tiene ningún tipo de control. WWU no puede ser
        responsable por el acceso de los Usuarios a enlaces creados dentro de
        la aplicación hacia otros recursos en Internet. La existencia de un
        enlace a otro sitio no constituye una validación de ese sitio o de su
        contenido. WWU no asume ninguna responsabilidad por el contenido de
        los sitios de terceros o su contenido al que los sitios de terceros
        pueden vincular. Los Usuarios son los únicos responsables de todas las
        transacciones realizadas con terceros.
      </Typography>
      <Typography gutterBottom color="textPrimary" variant="h5">
        6. RESPONSABILIDAD DEL USUARIO POR EL CONTENIDO Y COMPORTAMIENTO
      </Typography>
      <Typography gutterBottom align="justify" color="textPrimary">
        El Usuario es total y exclusivamente responsable por el contenido que
        muestra, descarga, envía o transmite por cualquier medio, en la
        utilización y acceso del Servicio, incluyendo sin limitación, por el
        contenido de las ofertas de trabajo y la información suministrada por
        el usuario candidato (el “Contenido”). Salvo por lo dispuesto
        expresamente en los presentes Términos y condiciones, WWU no garantiza
        la legalidad, integridad o calidad de dicho Contenido. En cualquier
        caso, WWU de ninguna manera se hace responsable por el Contenido, sea
        considerado o no ilegal en virtud de la normativa vigente, ni de los
        errores u omisiones en cualquier Contenido, y de sus consecuencias,
        tales como cualquier pérdida o daño como consecuencia de su uso. El
        Usuario queda informado expresamente que el uso de los Contenidos se
        hará bajo su exclusiva responsabilidad. Por lo tanto, sólo el Usuario
        de la cuenta es responsable de generar dicho Contenido por lo tanto
        asumirá tanto la eventual responsabilidad civil, penal y/o
        administrativa por el uso que hace de los Contenidos. El Usuario es el
        único responsable de su Contenido (generado por él) y garantiza que no
        contraviene las leyes y reglamentos vigentes, que no pueden causar
        lesiones a un tercero, que no infringe derechos de terceros y que no
        constituirán un incumplimiento de los presentes Términos y
        condiciones. El Usuario se compromete a respetar las leyes y
        reglamentos aplicables y de usar sólo contenido del cual dispone de
        los correspondientes derechos o para el cual el legítimo titular de
        los derechos ha dado su consentimiento expreso para su difusión, o que
        se encuentren libres de derechos de autor. El Usuario libera
        expresamente a WWU de todas las posibles reclamaciones de terceros a
        causa de la infracción de sus derechos o de cualquier comportamiento
        del Usuario que implique un incumplimiento de la ley aplicable o de
        estos Términos y condiciones. El Usuario se compromete a no utilizar
        el servicio para cualquier otro propósito que no consista en la oferta
        y demanda de empleo. Especialmente, sin limitación, se abstendrá de
        realizar a través del Servicio cualquier tipo de propaganda,
        proselitismo, publicidad –más allá de la estrictamente necesaria para
        la debida publicación de las ofertas de trabajo- o actos de
        denigración. El respeto por parte del Usuario empresa de las leyes
        mexicanas e internacionales relacionadas con el derecho del trabajo,
        incluidas el principio constitucional de igualdad y la prohibición de
        no discriminación en la contratación, es una condición esencial para
        usar el servicio. Se informa al Usuario empresa de las reglas que
        deben respetar las ofertas publicadas en WWU: (i) no deben superar el
        espacio destinado a ello (actualmente, 140 caracteres); (ii) deben ser
        puestos de trabajo o cursos de formación; (iii) en la descripción debe
        aparecer el lugar, el trabajo y el salario ofrecido; (iv) en la
        descripción no deben aparecer direcciones de email, números de
        teléfono o enlaces; (v) deben ser publicadas por empresas reales cuya
        razón social esté en México; (vi) deben respetar la legislación
        laboral mexicana; (vii) no pueden discriminar a los candidatos por
        razones de sexo, origen o condición física; (viii) no pueden ofrecer
        puestos de trabajo de network marketing o trabajo de autónomos; (ix)
        no pueden ser introducidas por empresas que no ofrecen un contrato de
        empleo regular; (x) no pueden hacer referencia a un intercambio entre
        particulares; (xi) no pueden contener elementos eróticos o
        pornográficos, explícitos o insinuados; y (xii) no puede publicarse la
        misma oferta para el mismo puesto de trabajo más de dos veces por mes.
        WWU se reserva el derecho a eliminar todos los anuncios que no cumplan
        con las normas mencionadas. Se informa al Usuario candidato que WWU se
        reserva el derecho de modificar o eliminar su presentación, si su
        utilización del Servicio no fuera profesional, incluyendo el borrado
        de su perfil, de su fotografía, si pudiera considerarse ofensiva, de
        índole explícitamente sexual o que pueda ser considerada generalmente
        inadecuada. En cualquier caso, WWU se reserva el derecho a modificar o
        eliminar todas las presentaciones y fotografías publicadas por los
        Usuarios si no se respetasen las leyes y reglamentos en vigor y/o se
        incumpliera los presentes Términos y condiciones y/o WWU considera que
        las presentaciones o fotografías van en detrimento de la calidad
        exigida por WWU y/o que pudieran dañar la imagen de marca de WWU. En
        el supuesto de incumplimiento de un Usuario de a una o más de las
        presentes normas, o en los casos de incumplimientos de las leyes o
        reglamentos, WWU se reserva el derecho de bloquear la cuenta del
        Usuario en cuestión y/o bloquear su acceso a todo o parte del
        Servicio, de manera temporal o permanentemente, sin que el Usuario
        tenga derecho a indemnización, y sin perjuicio de cualquier otros
        derecho que WWU pudiera disponer con arreglo a la legislación vigente,
        incluida el derecho a la reclamación por daños y perjuicios. El
        Usuario es el único responsable de los daños que pueda causar a otro
        Usuario o a un tercero por el uso del Servicio. Los Usuarios son los
        únicos responsables de cualquier transacción o relación contractual
        que se establezca entre ellos. WWU no será considerado de ninguna
        manera empresario con respecto a un candidato. Particularmente, WWU no
        se hace responsable, directa o indirectamente, de cualquier
        controversia entre una empresa y un candidato debido entre otros sin
        limitación por el rechazo de una candidatura, oferta de trabajo, o
        incumplimiento de una promesa de empleo o contrato de trabajo. La
        única y exclusiva relación contractual existente entre WWU y el
        Usuario es la establecida en los presentes Términos y condiciones.
        Fuerza Mayor: WWU no podrá ser considerado responsable o considerado
        que ha incumplido los presentes Términos y condiciones, en el caso de
        que WWU incumpliera cualquier disposición de los presentes Términos y
        condiciones debido un evento de fuerza mayor o caso fortuito, de
        acuerdo con la definición contenida en el Código Civil. Dichos hechos
        incluirán específicamente, ataques informáticos o interrupción o
        suspensión de las redes comunicaciones electrónicas o eléctricas.
      </Typography>
      <Typography gutterBottom color="textPrimary" variant="h5">
        7. MISCELÁNEA
      </Typography>
      <Typography gutterBottom align="justify" color="textPrimary">
        Las reglas que deben respetar las ofertas publicadas en WWU son: · No
        deben superar los 140 caracteres. · Deben ser puestos de trabajo o
        cursos de formación · En la descripción debe aparecer el lugar, el
        trabajo y el salario ofrecido · En la descripción no deben aparecer
        direcciones de email, números de teléfono y enlaces · Deben ser
        publicadas por empresas reales cuya razón social esté en México · Se
        debe respetar la legislación laboral mexicana · No se puede
        discriminar a los candidatos por razones de sexo, origen o condición
        física · No se puede ofrecer puestos de trabajo de network marketing o
        trabajo de autónomos. · No pueden ser introducidas por empresas que no
        ofrecen un contrato de empleo regular · No pueden hacer referencia a
        un intercambio entre particulares · No pueden contener elementos
        eróticos o pornográficos, explícitos o insinuados. · No puede
        publicarse la misma oferta para el mismo puesto de trabajo más de dos
        veces por mes · Está totalmente prohibido que las empresas pidan
        dinero a los candidatos a cambio de un puesto de trabajo (formación
        pagada, inversión inicial, maleta de productos...) En caso de que
        cualquier disposición de estos Términos y condiciones sea o se declare
        inválida o nula, ya sea en todo o en parte, la validez de las demás
        disposiciones no se verá afectada. Estos Términos y condiciones se
        regirán por la legislación mexicana. De acuerdo Nuestra web utiliza
        cookies para mejorar la experiencia de uso. Más información Política
        de Privacidad y de cookies Política de Privacidad Te informamos de que
        tus datos personales serán incorporados en un fichero del que es
        responsable WWU MÉXICO, SOCIEDAD ANÓNIMA PROMOTORA DE INVERSIÓN DE
        CAPITAL VARIABLE, con domicilio social en Ciudad de México, Bahía de
        Santa Bárbara #145, Col. Verónica Anzures, C.P. 11300, en proceso de
        inscripción en el Registro Público de Comercio del Distrito Federal y
        en el Registro Federal de Contribuyente (“WWU”) (en adelante “WWU”),
        con el fin de poderte prestar y ofrecer nuestros servicios; esto es,
        para: - La gestión y control de tu cuenta en WWU; - La gestión del
        proceso de selección; - La recepción y envío a usuarios-empresa de CVs
        de usuarios candidatos que opten a un puesto publicado por el
        usuario-empresa correspondiente; - La gestión y control del
        cumplimiento por el usuario de los términos y condiciones de nuestra
        aplicación y de su cuenta; - Mantenerte informado a través del envío
        de notificaciones PUSH (que no implicará el uso de tu email ni tu
        número de teléfono, y cuyo contenido versará principalmente acerca de
        ofertas de trabajo, actualizaciones, nuevas características, solución
        de problemas, inactividad o bajo uso, detección y prevención de los
        errores o en general para cumplir con los términos y condiciones); -
        La remisión periódica, por medios electrónicos, de información
        relativa a nuestros servicios. En todo caso, en tu área de usuario de
        nuestro podrás modificar tus preferencias respecto al envío de
        notificaciones PUSH o comunicaciones comerciales o desactivarlas por
        completo. Ten en cuenta que aunque decidas no suscribirte o se dé de
        baja de los correos electrónicos promocionales o newsletters puede que
        sigamos necesitando contactar contigo en referencia con información
        importante de índole no comercial. WWU solicitará los datos
        estrictamente necesarios para cumplir con la finalidad de la
        aplicación, tales como nombre, dirección, fotografía, teléfono, correo
        electrónico, estudios, profesión y otros datos necesarios. Se indicará
        expresamente la obligatoriedad o no de proporcionar datos. WWU ofrece
        la oportunidad de conocer a través de la aplicación de una forma
        rápida, personal y gratuita, ofertas de trabajo y/o profesionales que
        mejor se adapten al usuario. Para ello, el candidato tendrá que
        seleccionar las áreas geográficas para encontrar puestos de trabajo
        más cerca de su ubicación. WWU ha adoptado las medidas técnicas y
        organizativas que garantizan la seguridad de los datos de carácter
        personal y eviten su alteración, pérdida, tratamiento o acceso no
        autorizado, de acuerdo con la normativa de protección de datos y
        seguridad aplicables. Puedes remitir tus solicitudes de acceso,
        rectificación, cancelación y oposición (en particular, para no recibir
        nuestras comunicaciones comerciales) a nuestro domicilio social en
        Ciudad de México, Bahía de Santa Bárbara #145, Col. Verónica Anzures,
        C.P. 11300, con la referencia “Derechos Datos Personales”, acreditando
        para ello tu identidad, o por correo electrónico a support.mx@WWU.com
        o a través de la opción específica dentro de la aplicación. El usuario
        garantiza la autenticidad de todos aquellos datos que comunique a
        través de la aplicación y deberá mantener actualizada la información
        que facilite a WWU, de forma que responda en todo momento a su
        situación real, siendo el único responsable de las manifestaciones
        falsas o inexactas que realice, así como de los perjuicios que cause
        por ello a WWU o a terceros.
      </Typography>
    </main>
  );
};

export default CondicionesUso;
